import { Injectable } from '@angular/core';
import { MedicalServiceSearchItem } from '../../../model/medical-service-search-item';
import { PatientSearch } from '../../../model/patient/patient-search';
import { PatientService } from '../../patient.service';
import { PatientView } from '../../../model/patient/patient-view';
import { MedicalOrderOperation } from '../../../model/medical-order-operation';
import { MedicalAppointmentCareEditInfo, MedicalAppointmentCareStudyDelivery } from '../../../model/medical-appointment-care-edit-info';
import { MedicalServiceService } from '../../medical-service.service';
import { MedicalAppointmentCareUpdate } from '../../../model/medical-appointment-care-update';
import { ReferringPhysicianView } from 'src/app/model/referring-physician';
import { PhysicianService } from '../../physician.service';
import { PhysicianFilter } from '../../../model/physician-Filter';
import { StudyReportLockInfo } from '../../../model/study-report-lock-info';
import { StatusPhotography } from '../../../model/status-photography';

@Injectable()
export class MedicalServiceWizardService {

  private medicalConsultationObservation: string;
  private medicalConsultationMedication: string;
  medicalServiceSearchItem: MedicalServiceSearchItem;
  view: boolean;
  private patient: PatientView;
  private referringPhysicianView: ReferringPhysicianView;
  private physicianFilters: PhysicianFilter[];
  private medicalOrderOperation: MedicalOrderOperation;
  private medicalAppointmentCareEditInfo: MedicalAppointmentCareEditInfo;
  private medicalAppointmentCareUpdate: MedicalAppointmentCareUpdate;
  private medicalAppointmentCareStudyDeliveries: MedicalAppointmentCareStudyDelivery[];

  constructor(private patientService: PatientService
    , private physicianService: PhysicianService
    , private medicalService: MedicalServiceService) {
  }

  initialize(medicalServiceSearchItem: MedicalServiceSearchItem, view: boolean = false): Promise<MedicalAppointmentCareEditInfo> {
    this.reset();
    this.medicalServiceSearchItem = medicalServiceSearchItem;
    this.view = view;
    return this.getMedicalAppointmentCareEditInfo();
  }

  reset() {
    this.medicalOrderOperation = null;
    this.medicalServiceSearchItem = null;
    this.medicalConsultationMedication = null;
    this.medicalConsultationObservation = null;
    this.medicalAppointmentCareEditInfo = null;
    this.patient = null;
    this.physicianFilters = null;
    this.medicalAppointmentCareStudyDeliveries = [];
    this.view = false;
  }

  async getStatusPhotography(): Promise<StatusPhotography[]> {
    return this.medicalService.getStatusPhotography();
  }

  async getMedicalAppointmentCareEditInfo(): Promise<MedicalAppointmentCareEditInfo> {
    if (!this.medicalAppointmentCareEditInfo) {
      this.medicalAppointmentCareEditInfo =
        await this.medicalService
            .getMedicalAppointmentCareEditInfo(this.medicalServiceSearchItem.MedicalAppointmentId);
    }
    return this.medicalAppointmentCareEditInfo;
  }

  async getMedicalConsultationObservation(): Promise<string> {
    return this.medicalConsultationObservation;
  }

  async getMedicalConsultationMedication(): Promise<string> {
    return this.medicalConsultationMedication;
  }

  async getPatientView(): Promise<PatientView> {
    if (this.patient) {
      return this.patient;
    } else {
      return await this.patientService.getPatientView(this.medicalServiceSearchItem.PatientId);
    }
  }

  async getPosibleReportPhysicianFilters(): Promise<PhysicianFilter[]> {
    if (this.physicianFilters) {
      return this.physicianFilters;
    } else {
      return await this.physicianService.getPosibleReportPhysicianFilters
        (this.medicalServiceSearchItem.MedicalAppointmentId);
    }
  }


  async getReferringPhysicianView(): Promise<ReferringPhysicianView> {
    if (this.referringPhysicianView) {
      return this.referringPhysicianView;
    } else {
      return await this.physicianService.getReferringPhysicianViewByMedicalAppointmentId
      (this.medicalServiceSearchItem.MedicalAppointmentId);
    }
  }

  getMedicalOrderOperation(): MedicalOrderOperation {
    if (!this.medicalOrderOperation) {
      this.medicalOrderOperation = new MedicalOrderOperation();
      this.medicalOrderOperation.MedicalApponitmentId = this.medicalServiceSearchItem.MedicalAppointmentId;
      this.medicalOrderOperation.Protocol = this.medicalServiceSearchItem.Protocol;
      this.medicalOrderOperation.MedicalOrderId = this.medicalServiceSearchItem.MedicalOrderId;
    }
      return this.medicalOrderOperation;
  }

  setMedicalAppointmentCareStudyDeliveries(medicalAppointmentCareStudyDeliveries: MedicalAppointmentCareStudyDelivery[]) {
    this.medicalAppointmentCareStudyDeliveries = medicalAppointmentCareStudyDeliveries;
  }

  setMedicalAppointmentCareUpdate(medicalAppointmentCareUpdate: MedicalAppointmentCareUpdate) {
    this.medicalAppointmentCareUpdate = medicalAppointmentCareUpdate;
  }

  setMedicalConsultationObservation(medicalConsultationObservation: string) {
    this.medicalConsultationObservation = medicalConsultationObservation;
  }

  setMedicalConsultationMedication(medicalConsultationMedication: string) {
    this.medicalConsultationMedication = medicalConsultationMedication;
  }

  async finalizeMedicalAppointmentCare(): Promise<StudyReportLockInfo> {

    if (this.medicalAppointmentCareUpdate) {
      this.medicalAppointmentCareUpdate.IsEndAttention = true;
      return await this.MedicalAppointmentCareUpdate();
    }
    return null;
  }

  async keepMedicalAppointmentCare(): Promise<StudyReportLockInfo> {

    if (this.medicalAppointmentCareUpdate) {
      this.medicalAppointmentCareUpdate.IsEndAttention = false;
      return await this.MedicalAppointmentCareUpdate();
    }
    return null;
  }

  private async MedicalAppointmentCareUpdate(): Promise<StudyReportLockInfo> {
    this.medicalAppointmentCareUpdate.MedicalConsultationMedication =
      this.medicalConsultationMedication;

    this.medicalAppointmentCareUpdate.MedicalConsultationObservation =
      this.medicalConsultationObservation;

    this.medicalAppointmentCareUpdate.MedicalAppointmentCareStudyDeliveries =
      this.medicalAppointmentCareStudyDeliveries;

    return await this.medicalService.medicalAppointmentCareUpdate(this.medicalAppointmentCareUpdate);
  }

}
